import { isPromotionalOffer } from '../helpers/isOffer.helper';

import type { AvailabilityRoom, RoomOffers } from '~~/domains/graphql';

export function useAvailabilityRoomCheapestOffer(
  availabilityRoom?: AvailabilityRoom | Ref<AvailabilityRoom>,
) {
  const cheapestOffer = computed(() => {
    const rawAvailabilityRoom = isRef(availabilityRoom)
      ? availabilityRoom.value
      : availabilityRoom;

    if (!rawAvailabilityRoom) return;

    const { offers } = rawAvailabilityRoom;

    const sortedOffers = (
      JSON.parse(JSON.stringify(offers)) as RoomOffers[]
    ).sort((offer1, offer2) => {
      const firstOfferLowestPrice = offer1.pricing?.amount?.hotelKeeper ?? 0;
      const secondOfferLowestPrice = offer2.pricing?.amount?.hotelKeeper ?? 0;

      return firstOfferLowestPrice - secondOfferLowestPrice;
    });

    return sortedOffers[0];
  });

  const isCheapestOfferAMemberOffer = computed(() =>
    cheapestOffer.value?.categories?.some(isPromotionalOffer),
  );

  return { cheapestOffer, isCheapestOfferAMemberOffer };
}
